<template>
  <v-col cols="12" class="pt-3">
    <div>
      <v-chip
        v-for="chip in chips"
        :key="chip.key"
        class="ma-1"
        color="orange"
        text-color="white"
        small
        close
        @click:close="$emit('remove', chip)"
      >
        {{ chip.label }}
      </v-chip>
    </div>
  </v-col>
</template>

<script>
export default {
  name: "FiltrosAplicados",
  props: {
    chips: {
      type: Array,
      default: () => [],
      // Estrutura esperada:
      // [
      //   {
      //     key: 'ano',
      //     label: 'Ano: 2024'
      //   }
      // ]
    },
  },
};
</script>

<style scoped></style>
